import { Scanner } from "@/lib/types/scanner.ts";
import { scrollTo } from "@/lib/utils";
import { useNavigate } from "@tanstack/react-router";
import { IoMdQrScanner } from "react-icons/io";

type Props = {
  key: number,
  scanner: Scanner,
}

export const NodeScanner = ({ scanner }: Props) => {
  const navigate = useNavigate()

  const handleClick = () => {
    scrollTo(navigate, { to: "/scanners" }, `scanner-${scanner.id}`)
  }

  return (
    <div onClick={handleClick} className="p-2 rounded-lg border-2 border-gray-100 transition-transform duration-300 hover:scale-102 hover:cursor-pointer">
      <div className="flex items-center gap-2">
        <IoMdQrScanner />
        <span className="font-semibold font-[Inter]">{scanner.name}</span> <br />
      </div>
      <span className="text-muted text-sm">Areas {scanner.areas.length}</span>
      <br />
      <span className="text-muted text-sm">ID {scanner.id}</span>
    </div>
  )
}
